<!-- comparables.component.html -->
<div class="page">
  <header class="header">
    <h2>Comparables — Activity: {{ activityId() }}</h2>
  </header>

  <ng-container *ngIf="loading(); else content">
    <div class="loading">
      <div class="spinner" aria-label="Loading"></div>
      <div>Fetching comparables…</div>
    </div>
  </ng-container>

  <ng-template #content>
    <ng-container *ngIf="!error(); else errTpl">
      <!-- Quick analytics -->
      <!-- <section class="analytics">
        <div class="metric">
          <div class="value">{{ total() }}</div>
          <div class="label">Total comps</div>
        </div>
        <div class="metric">
          <div class="value">{{ uniquePropertyTypes() }}</div>
          <div class="label">Unique property types</div>
        </div>
        <div class="metric">
          <div class="value">{{ topCity() }}</div>
          <div class="label">Top city</div>
        </div>
      </section> -->

      <!-- Category cards -->
      <section class="cards">
        <button class="card" (click)="goTo('sales')">
          <div class="title">Sales</div>
          <div class="count">{{ salesCount() }}</div>
          <div class="hint">View sales comparables →</div>
        </button>

        <button class="card" (click)="goTo('expense')">
          <div class="title">Expense</div>
          <div class="count">{{ expenseCount() }}</div>
          <div class="hint">View expense comparables →</div>
        </button>

        <button class="card" (click)="goTo('land')">
          <div class="title">Land</div>
          <div class="count">{{ landCount() }}</div>
          <div class="hint">View land comparables →</div>
        </button>

        <button class="card" (click)="goTo('rent')">
          <div class="title">Rent</div>
          <div class="count">{{ rentCount() }}</div>
          <div class="hint">View rent comparables →</div>
        </button>
      </section>

      <!-- Child view -->
      <section class="child">
        <router-outlet></router-outlet>
      </section>
    </ng-container>

    <ng-template #errTpl>
      <div class="error">
        {{ error() }}
      </div>
    </ng-template>
  </ng-template>
</div>
